import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';

export const ExportColumnsDialog = ({
  open,
  onOpenChange,
  title,
  description,
  columns,
  selectedColumns,
  onToggleColumn,
  onSelectAll,
  onConfirm,
  confirmLabel = 'Exportar XLSX',
  dataTestId = 'export-columns-dialog',
}) => {
  const allSelected = columns.length > 0 && columns.every((column) => selectedColumns.includes(column.key));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl" data-testid={dataTestId}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="flex items-center justify-between rounded-xl border border-slate-200 bg-slate-50 px-3 py-2">
            <div>
              <p className="text-sm font-medium text-slate-900">Colunas incluídas</p>
              <p className="text-xs text-slate-500">Seleccione exactamente os campos que quer levar no XLSX.</p>
            </div>
            <Button type="button" variant="outline" size="sm" onClick={() => onSelectAll(!allSelected)} data-testid={`${dataTestId}-toggle-all-button`}>
              {allSelected ? 'Limpar' : 'Seleccionar tudo'}
            </Button>
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            {columns.map((column) => (
              <label key={column.key} className="flex items-center gap-3 rounded-xl border border-slate-200 px-3 py-3 text-sm">
                <Checkbox
                  checked={selectedColumns.includes(column.key)}
                  onCheckedChange={() => onToggleColumn(column.key)}
                  data-testid={`${dataTestId}-column-${column.key}`}
                />
                <span>{column.label}</span>
              </label>
            ))}
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid={`${dataTestId}-cancel-button`}>
            Cancelar
          </Button>
          <Button onClick={onConfirm} disabled={!selectedColumns.length} data-testid={`${dataTestId}-confirm-button`}>
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};